module.exports = (__webpack_require__(78))(3);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/process/browser.js from dll-reference vendor
// module id = 130
// module chunks = 0